export default {
    name: "Sea Import",
    meta: {
        icon: "accessibility",
        expanded: true,
        auth: true
    },
    departmentName: "Client",
    finalPagePermision: "",
    children: [{
        name: "Sea-Import Normal Details",
        path: "/SeaImp/clientSeaImpNormal",
        meta: {
            icon: "accessibility",
            auth: true
        },
        component: require("../component/clientDashboard/clientSeaImpNormal.vue"),
        finalPagePermision: "",

    },
    {
        name: "Sea-Import Conso Details",
        path: "/SeaImp/clientSeaImpConso",
        meta: {
            icon: "accessibility",
            auth: true
        },
        component: require("../component/clientDashboard/clientSeaImpConso.vue"),
        finalPagePermision: "",

    },


    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/clientSeaImpDash.js